import useResource from 'app/hooks/useResource';

import {
  getKiosksV2,
  setKioskParams
} from 'app/actions/kiosks';

import {
  createKiosk,
  updateKiosk,
  //destroyKiosk
} from 'app/services/kiosks';

import {
  kiosks as resource
} from 'app/resources';

const useKiosks = props => {
  const {
    onUpdate
  } = props;

  return useResource({
    resource,
    getResource: getKiosksV2,
    createResource: createKiosk,
    updateResource: updateKiosk,
    setResourceParams: setKioskParams,
    onUpdate
    //destroyResource: destroyKiosk
  });
}

export default useKiosks;
